export default {
      id: "select-lines-usage",
      viewBox: "0 0 16 10",
      url: __webpack_public_path__ + "sprite.svg#select-lines-usage",
      toString: function () {
        return this.url;
      }
    }